import {
  ArrowLeftOutlined,
  CheckCircleOutlined,
  CheckOutlined,
  ContainerOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  EllipsisOutlined,
  HistoryOutlined,
  PlusOutlined,
  StarFilled,
  StarTwoTone,
  UserAddOutlined,
  CloseOutlined,
  LockOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  Dropdown,
  Menu,
  message,
  Modal,
  Row,
  Tabs,
  Tag,
  Tooltip,
  Table,
} from 'antd'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import React, { useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { useHistory, useParams } from 'react-router-dom'
import { greenPrimary } from '../../../color'
import { EmptyText } from '../../../components/Common/CellText'
import { systemName } from '../../../config'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  STATUS_DEFAULT,
  WORK_STATUS,
  TYPE_STATUS,
} from '../../../constants'
import date_format from '../../../date_format'
import DashboardLayout from '../../../layouts/DashboardLayout/DashboardLayout'
import { WorkRequest } from '../../../requests/WorkRequest'
import utils from '../../../utils'
import {
  InfoBlock,
  InfoLabel,
  InfoValue,
  TabsWrapper,
} from './WorkDetailPageStyled'

import PopoverWatchTime from '../../../components/PopoverWatchTime'
import { VIEWLOG_DATE } from '../../../constants'
import WorkDetailCommentList from './WorkDetailCommentList'
import WorkPdf from '../DrawerWork/WorkPdf'

import { List } from 'antd'
import FileItem from '../../../components/Common/FileItemComponent/FileItem'
import ListHistoryLogModal from '../../ListHistoryLog/ListHistoryLogModal'
import PopupAddPersonWork from '../PopupAddPersonWork'
import PopupElectronicReleaseForm from '../PopupElectronicReleaseForm'
import PopupAddPersonVote from '../PopupVote/PopupAddPersonVote'
import { VOTE_STATUS_CONFIG } from './constants'
import { Link } from 'react-router-dom'
import WorkDetailCreateSubTaskModal from './WorkDetailCreateSubTaskModal'
import { Badge } from 'antd'
import { StatusTag } from '../../../components/Common/StatusTag'
import { SubWorkListItemStyled } from './WorkDetailPageStyled'

import useOpenItem from '../../../hooks/useOpenItem'

const { TabPane } = Tabs
const { confirm } = Modal

const WorkDetailPage = props => {
  const {
    selectUserStore,
    workStore,
    authenticationStore,
    loadingAnimationStore,
    selectPeopleStore,
    voteStore,
    aclStore,
  } = props

  const { code_work } = useParams()
  const history = useHistory()

  const { workDetail, commentWorkList } = workStore
  const { currentUser } = authenticationStore

  const [commentList, setCommentList] = useState([])
  const [isShowDelComments, setIsShowDelComments] = useState(false)
  const [isMarkingImportant, setIsMarkingImportant] = useState(false)
  const [isImportantWork, setIsImportantWork] = useState(false)
  const [isVisibleAddPersonWork, setIsVisibleAddPersonWork] = useState(false)
  const [isVisibleAddPersonVote, setIsVisibleAddPersonVote] = useState(false)
  const [isVisibleReleaseModal, setIsVisibleReleaseModal] = useState(false)
  const [isVisibleHistory, setIsVisibleHistory] = useState(false)
  const [documentHistory, setDocumentHistory] = useState({})

  // Use Open Items for Popups
  const [isOpenCreateSubTaskModal, setIsOpenCreateSubTaskModal] = useState(false)

  useEffect(() => {
    if (code_work) {
      fetchWorkDetail()
    }
  }, [code_work])

  const fetchWorkDetail = async () => {
    loadingAnimationStore.showSpinner(true)
    try {
      await workStore.getWorkDetail(code_work)
      await getCommentWorkList()
      try {
        await voteStore.getVoteDetail(code_work)
      } catch (e) {
        console.log(e)
      }
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra')
      history.push('/works')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const getCommentWorkList = async () => {
    try {
      await workStore.getCommentWorkList(code_work)
    } catch (err) {
      console.log(err)
    }
  }

  const handleSendVote = async (userCode, voteResult) => {
    try {
      loadingAnimationStore.showSpinner(true)
      await voteStore.updateVote(userCode, { result: voteResult })
      await voteStore.getVoteDetail(code)
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const {
    assignees,
    attachments,
    code,
    content,
    due_date,
    start_date,
    status,
    subwork,
    parent_id,
    title,
    overdue,
    work_type,
    outgoingDocument,
    important,
    created_at,
    permission,
  } = workDetail || {}

  const isElectronicWork = work_type === WORK_STATUS.ELECTRONIC

  const isCrawledWork =
    workDetail?.is_local_edited === false ||
    workDetail?.isLocalEdited === false ||
    (title && typeof title === 'string' && title.includes('IMSAT')) ||
    (code && String(code).includes('IMSAT'))

  useEffect(() => {
    setIsImportantWork(!!important)
  }, [important, workDetail])

  const renderDate = date => {
    if (!date) return <EmptyText>Không rõ</EmptyText>
    return (
      <span style={{ fontStyle: 'italic' }}>
        {date_format.DATE_FORMAT_SLASH(date)}
      </span>
    )
  }

  const handleUpdateStatusWork = async newStatus => {
    loadingAnimationStore.showSpinner(true)
    try {
      await workStore.updateStatusWork(code, newStatus)
      await fetchWorkDetail()
      if (newStatus === STATUS_DEFAULT.COMPLETE) {
        message.success('Bạn đã đánh dấu công việc hoàn thành!')
      } else {
        message.success('Bạn đã đánh dấu công việc là đang thực hiện!')
      }
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Lỗi cập nhật trạng thái')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const handleDeleteWork = async () => {
    loadingAnimationStore.showSpinner(true)
    try {
      await workStore.deleteWork(code)
      history.replace('/works')
    } catch (err) {
      message.error(err.vi || 'Lỗi xoá công việc')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const exportWork = () => {
    utils.exportPDF('divToPrint', title)
  }

  const handleMarkImportantWork = async () => {
    try {
      setIsMarkingImportant(true)
      await WorkRequest.markImportantWork(code, !isImportantWork)
      setIsImportantWork(!isImportantWork)
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setIsMarkingImportant(false)
    }
  }

  const checkPermission = useCallback(
    key => {
      if (!permission) return false
      if (Array.isArray(permission)) return permission.includes(key)
      if (typeof permission === 'string')
        return permission.split(',').includes(key)
      return false
    },
    [permission]
  )

  const handleOpenPopupAddPersonVote = () => {
    setIsVisibleAddPersonVote(true)
  }

  const handlerList =
    assignees?.length >= 0 && selectUserStore?.convertListToDefault
      ? selectUserStore.convertListToDefault(
          toJS(assignees).filter(
            el =>
              el.permission === ASSIGNEE_TYPE.HANDLER &&
              el.assignee_code !== 'admin'
          )
        )
      : []
  const followerList =
    assignees?.length >= 0 && selectUserStore?.convertListToDefault
      ? selectUserStore.convertListToDefault(
          toJS(assignees).filter(
            el =>
              el.permission === ASSIGNEE_TYPE.FOLLOWER &&
              el.assignee_code !== 'admin'
          )
        )
      : []

  const menuButton = (
    <Menu>
      <>
        {!isCrawledWork &&
          (currentUser?.username ===
            (assignees?.length >= 0
              ? assignees.find(el => el.permission === ASSIGNEE_TYPE.CREATE)
                  ?.assignee_code
              : null) ||
            handlerList.some(el => currentUser?.username === el.id)) && (
            <Menu.Item
              key="add_assignee"
              icon={<UserAddOutlined style={{ color: '#595959' }} />}
              onClick={() => setIsVisibleAddPersonWork(true)}>
              <span style={{ color: '#595959' }}>Thêm người</span>
            </Menu.Item>
          )}
        {status !== STATUS_DEFAULT.COMPLETE &&
          !isCrawledWork &&
          !parent_id &&
          aclStore.checkAccessControlAction(
            ACL_ACTION_TYPE.phat_hanh__WORK
          ) && (
            <Menu.Item
              key="release"
              icon={<ContainerOutlined style={{ color: '#595959' }} />}
              onClick={() => setIsVisibleReleaseModal(true)}>
              <span style={{ color: '#595959' }}>Phát hành điện tử</span>
            </Menu.Item>
          )}
        {status !== STATUS_DEFAULT.COMPLETE && !isCrawledWork && (
          <Menu.Item
            key="vote"
            icon={<EditOutlined style={{ color: '#595959' }} />}
            onClick={() => handleOpenPopupAddPersonVote()}>
            <span style={{ color: '#595959' }}>Lấy ý kiến</span>
          </Menu.Item>
        )}
        <Menu.Item
          key="history"
          icon={<HistoryOutlined style={{ color: '#595959' }} />}
          onClick={() => {
            setDocumentHistory({ code: workDetail.code })
            setIsVisibleHistory(true)
          }}>
          <span style={{ color: '#595959' }}>Lịch sử</span>
        </Menu.Item>
        <Menu.Item
          key="export"
          icon={<DownloadOutlined style={{ color: '#595959' }} />}
          onClick={exportWork}>
          <span style={{ color: '#595959' }}>In</span>
        </Menu.Item>
        {!isCrawledWork && aclStore.checkAccessControlAction(ACL_ACTION_TYPE.delete__WORK) && (
          <Menu.Item
            key="delete"
            icon={<DeleteOutlined style={{ color: '#ff4d4f' }} />}
            onClick={() => {
              Modal.confirm({
                title: 'Xóa công việc',
                content: 'Bạn có chắc chắn muốn xóa công việc này không?',
                onOk: handleDeleteWork,
              })
            }}>
            <span style={{ color: '#ff4d4f' }}>Xóa công việc</span>
          </Menu.Item>
        )}
      </>
    </Menu>
  )

  if (!workDetail || !code) return null

  return (
    <DashboardLayout>
      <Helmet>
        <title>Chi tiết công việc | {systemName} Công việc</title>
      </Helmet>

      <div
        style={{
          padding: '24px',
          width: '100%',
          minHeight: 'calc(100vh - 64px)',
        }}>
        {/* HEADER BLOCK (Nền trắng mặc định) */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 24,
          }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Button
              type="text"
              icon={<ArrowLeftOutlined />}
              onClick={() => history.push('/works')}
              style={{ fontSize: 18, color: '#595959' }}
            />
            <h2 style={{ margin: 0, fontSize: 22, fontWeight: 600 }}>
              {title}
            </h2>
            {status === STATUS_DEFAULT.COMPLETE ? (
              <Tag
                color={'success'}
                style={{ borderRadius: 4, fontWeight: 500, margin: 0 }}>
                Hoàn thành
              </Tag>
            ) : (
              <Tag
                color={'processing'}
                style={{ borderRadius: 4, fontWeight: 500, margin: 0 }}>
                Đang thực hiện
              </Tag>
            )}
          </div>

          <div style={{ display: 'flex', gap: 12 }}>
            {isCrawledWork ? (
              <Button
                disabled
                icon={<LockOutlined />}
                style={{
                  fontWeight: 500,
                  backgroundColor: '#fafafa',
                  borderColor: '#d9d9d9',
                  color: '#595959',
                  cursor: 'default',
                }}>
                Bản ghi IMSAT (Chỉ xem)
              </Button>
            ) : (
              <>
                {status !== STATUS_DEFAULT.COMPLETE &&
                  aclStore.checkAccessControlAction(
                    ACL_ACTION_TYPE.cap_nhat_trang_thai__WORK
                  ) && (
                    <Button
                      type="primary"
                      shape="round"
                      style={{
                        background: '#2CA87F',
                        borderColor: '#2CA87F',
                        fontWeight: 500,
                      }}
                      icon={<CheckOutlined />}
                      onClick={() =>
                        handleUpdateStatusWork(STATUS_DEFAULT.COMPLETE)
                      }>
                      Hoàn thành
                    </Button>
                  )}

                {status === STATUS_DEFAULT.COMPLETE &&
                  aclStore.checkAccessControlAction(
                    ACL_ACTION_TYPE.cap_nhat_trang_thai__WORK
                  ) && (
                    <Button
                      shape="round"
                      style={{
                        fontWeight: 500,
                        background: '#fff',
                        borderColor: '#d9d9d9',
                        color: '#ff4d4f',
                      }}
                      icon={<CloseOutlined />}
                      onClick={() =>
                        handleUpdateStatusWork(STATUS_DEFAULT.PENDING)
                      }>
                      Chưa hoàn thành
                    </Button>
                  )}

                {aclStore.checkAccessControlAction(
                  ACL_ACTION_TYPE.edit__WORK
                ) && (
                  <Button
                    shape="round"
                    icon={<EditOutlined />}
                    style={{
                      fontWeight: 500,
                      background: '#fff',
                      borderColor: '#d9d9d9',
                    }}
                    onClick={() => history.push('/works/update/' + code)}>
                    Chỉnh sửa
                  </Button>
                )}
              </>
            )}

            <Dropdown
              overlay={menuButton}
              trigger={['click']}
              placement="bottomRight"
              overlayStyle={{ borderRadius: 12, overflow: 'hidden', boxShadow: '0 6px 20px rgba(0,0,0,0.12)' }}>
              <Button
                icon={<EllipsisOutlined style={{ color: '#1890ff' }} />}
                style={{
                  borderRadius: 8,
                  transform: 'rotate(90deg)',
                  borderColor: '#1890ff',
                  color: '#1890ff',
                }}
              />
            </Dropdown>
          </div>
        </div>

        {/* CONTENT WRAPPER (Nền xám, bo góc) */}
        <div style={{ background: '#f8f9fa', borderRadius: 12, padding: 24 }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 24,
            }}>
            <h3 style={{ fontSize: 16, fontWeight: 600, margin: 0 }}>
              Thông tin chung
            </h3>
            {isMarkingImportant ? (
              <Button
                type="text"
                icon={<StarTwoTone twoToneColor={'#bfbfbf'} />}
              />
            ) : (
              <Tooltip
                title={
                  isImportantWork ? 'Bỏ đánh dấu ưu tiên' : 'Đánh dấu ưu tiên'
                }>
                <Button
                  type="text"
                  onClick={handleMarkImportantWork}
                  icon={
                    isImportantWork ? (
                      <StarFilled style={{ color: '#faad14' }} />
                    ) : (
                      <StarTwoTone twoToneColor={'#bfbfbf'} />
                    )
                  }
                />
              </Tooltip>
            )}
          </div>

          <Row gutter={[24, 24]} align="middle">
            <Col span={24}>
              <Row gutter={[24, 24]}>
                {parent_id && (
                  <Col span={24}>
                    <InfoBlock>
                      <InfoLabel>Công việc chính</InfoLabel>
                      <InfoValue>
                        <Link to={`/works/view/${parent_id}`}>
                          {workDetail?.parent_title || parent_id}
                        </Link>
                      </InfoValue>
                    </InfoBlock>
                  </Col>
                )}
                <Col span={12}>
                  <InfoBlock>
                    <InfoLabel>Ngày bắt đầu</InfoLabel>
                    <InfoValue>{renderDate(start_date)}</InfoValue>
                  </InfoBlock>
                  <InfoBlock>
                    <InfoLabel>Người xử lý</InfoLabel>
                    <InfoValue>
                      {handlerList.length > 0 ? (
                        <PopoverWatchTime
                          userList={handlerList}
                          title="Danh sách người xử lý"
                          isFullViewer={true}
                          compared_date={VIEWLOG_DATE.work_read_until}
                          typeId={workDetail?.code}
                          created_at={workDetail?.created_at}
                        />
                      ) : (
                        <EmptyText>Không có.</EmptyText>
                      )}
                    </InfoValue>
                  </InfoBlock>
                </Col>

                <Col span={12}>
                  <InfoBlock>
                    <InfoLabel>Ngày kết thúc</InfoLabel>
                    <InfoValue>{renderDate(due_date)}</InfoValue>
                  </InfoBlock>
                  <InfoBlock>
                    <InfoLabel>Người theo dõi</InfoLabel>
                    <InfoValue>
                      {followerList.length > 0 ? (
                        <PopoverWatchTime
                          userList={followerList}
                          title="Danh sách người theo dõi"
                          isFullViewer={true}
                          compared_date={VIEWLOG_DATE.work_read_until}
                          typeId={workDetail?.code}
                          created_at={workDetail?.created_at}
                        />
                      ) : (
                        <EmptyText>Không có.</EmptyText>
                      )}
                    </InfoValue>
                  </InfoBlock>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row style={{ marginTop: 24 }}>
            <Col span={24}>
              <InfoBlock>
                <InfoLabel>Nội dung</InfoLabel>
                <InfoValue>
                  {content ? (
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                  ) : (
                    <EmptyText>Không có.</EmptyText>
                  )}
                </InfoValue>
              </InfoBlock>
              <InfoBlock>
                <InfoLabel>
                  File đính kèm ({attachments?.length || 0})
                </InfoLabel>
                <InfoValue>
                  {attachments && attachments.length > 0 ? (
                    <div
                      style={{
                        marginTop: 8,
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 8,
                      }}>
                      {attachments.map(file => (
                        <FileItem
                          key={file.file_id}
                          file_id={file.file_id}
                          file_name={file.file_name}
                          file_type={utils.getExtensionFile(file.file_name)}
                        />
                      ))}
                    </div>
                  ) : (
                    <EmptyText>Không có tài liệu đính kèm.</EmptyText>
                  )}
                </InfoValue>
              </InfoBlock>
            </Col>
          </Row>

          {voteStore?.voteDetail?.length > 0 && (
            <Row style={{ marginTop: 24 }}>
              <Col span={24}>
                <InfoBlock>
                  <InfoLabel>Danh sách lấy ý kiến</InfoLabel>
                  <InfoValue>
                    <Table
                      className="customTable"
                      dataSource={voteStore?.voteDetail || []}
                      pagination={false}
                      columns={[
                        {
                          title: 'Người dùng',
                          dataIndex: 'name_uppercase',
                          key: 'name_uppercase',
                          width: 200,
                          render: value => (
                            <span style={{ fontSize: 12, textTransform: 'capitalize' }}>
                              {value?.toLowerCase()}
                            </span>
                          ),
                        },
                        {
                          title: 'Ý kiến',
                          dataIndex: 'vote_status',
                          key: 'vote_status',
                          width: 200,
                          render: (_, record) => {
                            const { result } = record || {}
                            const tagConfig = VOTE_STATUS_CONFIG.find(item => {
                              if (result === null || result === undefined) {
                                return item.value === null
                              }
                              return item.value === result
                            })

                            return (
                              <Tag
                                style={{ border: 'none', borderRadius: '4px' }}
                                color={tagConfig?.color}>
                                {tagConfig?.label}
                              </Tag>
                            )
                          },
                        },
                        {
                          title: '',
                          dataIndex: 'action',
                          key: 'action',
                          width: 80,
                          render: (_, record) => {
                            const { assignee_code } = record || {}

                              const menuOverlay = (
                                <Menu onClick={props => {
                                  const { key } = props || {}
                                  if (record?.code) {
                                    handleSendVote(record.code, key === 'true')
                                  }
                                }}>
                                  <Menu.Item key="true">Đồng ý</Menu.Item>
                                  <Menu.Item key="false">Không đồng ý</Menu.Item>
                                </Menu>
                              )

                            return currentUser.username === assignee_code ? (
                              <Dropdown
                                overlay={menuOverlay}
                                trigger={['click']}>
                                <Button type="primary" style={{ borderRadius: '8px' }}>
                                  Gửi ý kiến
                                </Button>
                              </Dropdown>
                            ) : null
                          },
                        },
                      ]}
                    />
                  </InfoValue>
                </InfoBlock>
              </Col>
            </Row>
          )}

          <TabsWrapper style={{ marginTop: 24 }}>
            <Tabs
              defaultActiveKey="1"
              tabBarStyle={{ borderBottom: '1px solid #d9d9d9' }}>
              <TabPane tab="Ý kiến" key="1" forceRender>
                <div style={{ paddingTop: '24px' }}>
                  <WorkDetailCommentList isCrawledWork={isCrawledWork} />
                </div>
              </TabPane>

              {!parent_id && (
                <TabPane
                  tab={
                    <span>
                      Công việc phụ{' '}
                      <Badge
                        count={subwork?.length || 0}
                        style={{ backgroundColor: '#bfbfbf' }}
                      />
                    </span>
                  }
                  key="2">
                  <div style={{ paddingTop: '24px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                      <span style={{ fontWeight: 600, color: '#262626' }}>Công việc phụ</span>
                      {status !== STATUS_DEFAULT.COMPLETE &&
                        aclStore.checkAccessControlAction(
                          ACL_ACTION_TYPE.them_cong_viec_phu__WORK
                        ) &&
                        !parent_id && (
                          <Button
                            type="primary"
                            onClick={() => setIsOpenCreateSubTaskModal(true)}>
                            Thêm công việc phụ
                          </Button>
                        )}
                    </div>
                    <List
                      size={'small'}
                      locale={{
                        emptyText: <EmptyText>Không có công việc phụ</EmptyText>,
                      }}
                      dataSource={subwork || []}
                      renderItem={item => (
                        <SubWorkListItemStyled
                          key={item.code}
                          onClick={() => history.push('/works/view/' + item.code)}>
                          <div>
                            <p>{item.title}</p>
                            <span style={{ textTransform: 'uppercase' }}>{item.updated_user || item.created_user}</span>
                          </div>
                          {StatusTag(TYPE_STATUS.WORK, item.status)}
                        </SubWorkListItemStyled>
                      )}
                    />
                  </div>
                </TabPane>
              )}
            </Tabs>
          </TabsWrapper>
        </div>

        {/* Popups */}
        {isOpenCreateSubTaskModal && (
          <WorkDetailCreateSubTaskModal
            parentCode={code}
            isOpenModal={isOpenCreateSubTaskModal}
            setIsOpenModal={setIsOpenCreateSubTaskModal}
          />
        )}

        {isVisibleAddPersonWork && (
          <PopupAddPersonWork
            assignees={assignees}
            workStore={workStore}
            isVisibleAddPersonWork={isVisibleAddPersonWork}
            handleCloseAddPersonWork={() => setIsVisibleAddPersonWork(false)}
          />
        )}

        {isVisibleAddPersonVote && (
          <PopupAddPersonVote
            isVisibleAddPersonVote={isVisibleAddPersonVote}
            handleCloseAddPersonVote={() => setIsVisibleAddPersonVote(false)}
            workDetail={workDetail}
          />
        )}

        {isVisibleReleaseModal && (
          <PopupElectronicReleaseForm
            isVisiblePopupElectronicRelease={isVisibleReleaseModal}
            handleCloseElectronicRelease={() =>
              setIsVisibleReleaseModal(false)
            }
          />
        )}

        {isVisibleHistory && (
          <ListHistoryLogModal
            type={'WORK'}
            isVisible={isVisibleHistory}
            taskInfo={documentHistory}
            handleCloseHistory={() => {
              setIsVisibleHistory(false)
              setDocumentHistory({})
            }}
          />
        )}

        <div style={{ display: 'none' }}>
          <WorkPdf
            workDetail={workDetail}
            commentList={commentWorkList?.filter(item => !item.isHidden) || []}
            isImportantWork={isImportantWork}
            attachments={attachments || []}
            voteList={voteStore?.voteDetail || []}
          />
        </div>
      </div>
    </DashboardLayout>
  )
}

export default inject(
  'workStore',
  'authenticationStore',
  'loadingAnimationStore',
  'selectPeopleStore',
  'voteStore',
  'selectUserStore',
  'aclStore'
)(observer(WorkDetailPage))
